import React from 'react';
import styles from '../css/comuns/Banner.module.css';
import { config } from '../../data';

const Banner = () => {
  return (
    <section className={styles['secao-banner']}>
      <div className={styles['bolinhas-banner']}></div>
      <div className="container text-center">
        <h1 className="display-4">{config.texts.banner.title}</h1>
        <p className="lead">{config.texts.banner.subtitle}</p>
        <a href="#servicos" className={`btn btn-lg ${styles['botao-oni']} mt-3`}>{config.texts.banner.buttonText}</a>
      </div>
    </section>
  );
};

export default Banner;